<template>
  <div>
    主页
  </div>
</template>

<script>
export default {
  name: 'home',
  data () {
    return {
      form: {
        name: '',
        region: '',
        date1: '',
        date2: '',
        delivery: false,
        type: [],
        resource: '',
        desc: ''
      }
    }
  },
  methods: {
    onSubmit () {
      console.log(1)
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/views/home/index.vue